import axios from 'axios'
import { packageUrl, getHeader } from '@/config'

const state = {
  packageList: []
}

const mutations = {
  SET_PACKAGE_LIST (state, obj) {
    state.packageList = obj
  }
}

const actions = {
  getPackageList: ({ commit }) => {
    axios.get(packageUrl, { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_PACKAGE_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
